import React, { useState } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
const RichText = dynamic(() => import('../../RichText/RichText'));
import { Constants } from '../../../adapters/helpers/Constants';
import { optimizeImage } from '../../../adapters/helpers/pagespeedHelper';
export default function ProductShowMoreAccordion(props) {
  var _doc$fields, _doc$fields2, _doc$fields2$seeMoreL, _doc$fields2$seeMoreL2, _doc$fields2$seeMoreL3, _doc$fields2$seeMoreL4, _doc$fields2$seeMoreL5, _doc$fields3, _doc$fields3$seeLessL, _doc$fields3$seeLessL2, _doc$fields3$seeLessL3, _doc$fields3$seeLessL4, _doc$fields3$seeLessL5;
  const {
    document: doc,
    productHighlights
  } = props;
  const highlightsLabel = doc == null ? void 0 : (_doc$fields = doc.fields) == null ? void 0 : _doc$fields.highlightsLabel;
  const seeMoreLabelIcon = doc == null ? void 0 : (_doc$fields2 = doc.fields) == null ? void 0 : (_doc$fields2$seeMoreL = _doc$fields2.seeMoreLabel) == null ? void 0 : (_doc$fields2$seeMoreL2 = _doc$fields2$seeMoreL.fields) == null ? void 0 : (_doc$fields2$seeMoreL3 = _doc$fields2$seeMoreL2.icon) == null ? void 0 : (_doc$fields2$seeMoreL4 = _doc$fields2$seeMoreL3.fields) == null ? void 0 : (_doc$fields2$seeMoreL5 = _doc$fields2$seeMoreL4.file) == null ? void 0 : _doc$fields2$seeMoreL5.url;
  const seeLessLabelIcon = doc == null ? void 0 : (_doc$fields3 = doc.fields) == null ? void 0 : (_doc$fields3$seeLessL = _doc$fields3.seeLessLabel) == null ? void 0 : (_doc$fields3$seeLessL2 = _doc$fields3$seeLessL.fields) == null ? void 0 : (_doc$fields3$seeLessL3 = _doc$fields3$seeLessL2.icon) == null ? void 0 : (_doc$fields3$seeLessL4 = _doc$fields3$seeLessL3.fields) == null ? void 0 : (_doc$fields3$seeLessL5 = _doc$fields3$seeLessL4.file) == null ? void 0 : _doc$fields3$seeLessL5.url;
  const highlightList = productHighlights ? Object.keys(productHighlights).map(key => {
    return <li key={key} className={`ob-product-highlights__highlights-list-item ob-hyperlink-highlights-li `}>
                      <RichText document={productHighlights[key]} />
                  </li>;
  }) : [];
  const [mobileShowMore, setMobileShowMore] = useState(false);
  return <div>
            <button onClick={() => {
      setMobileShowMore(!mobileShowMore);
    }}>
                <span>{highlightsLabel}</span>
                <img src={mobileShowMore ? optimizeImage(seeMoreLabelIcon) : optimizeImage(seeLessLabelIcon)} alt={Constants.chevronDown} fetchPriority="high"></img>
            </button>
            {mobileShowMore && <ul>{highlightList}</ul>}
        </div>;
}
ProductShowMoreAccordion.propTypes = {
  document: PropTypes.object,
  productHighlights: PropTypes.object
};